"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTemporaryJoinData = exports.loadFilterData = exports.setDataCache = exports.setCrudeFilter = exports.setReloadListEntity = exports.addMessage = exports.setShowCollapse = exports.setShowDialog = exports.setDataDisplayMode = exports.setTableFilterSettings = exports.setLastActiveEntity = exports.setActiveEntity = exports.setActiveTab = exports.setCrudeTabs = exports.setCrudePath = exports.setDarkMode = exports.setEditLayout = exports.setCrudeLicense = exports.setAppLayout = exports.setCrudeConfiguration = exports.setCrudeLabels = exports.setCrudeSchema = exports.setTheme = exports.setScreenDesign = exports.setLanguage = exports.setUser = exports.actionCreator = void 0;
var typescript_fsa_1 = __importDefault(require("typescript-fsa"));
exports.actionCreator = typescript_fsa_1.default('LOGIN');
/*
 * Actions
 */
exports.setUser = exports.actionCreator('SET_USER');
exports.setLanguage = exports.actionCreator('SET_LANGUAGE');
exports.setScreenDesign = exports.actionCreator('SET_SCREEN_DESIGN');
exports.setTheme = exports.actionCreator('SET_THEME');
exports.setCrudeSchema = exports.actionCreator('SET_CRUDE_SCHEMA');
exports.setCrudeLabels = exports.actionCreator('SET_CRUDE_LABELS');
exports.setCrudeConfiguration = exports.actionCreator('SET_CRUDE_CONFIGURATION');
exports.setAppLayout = exports.actionCreator('SET_APP_LAYOUT');
exports.setCrudeLicense = exports.actionCreator('SET_CRUDE_LICENSES');
exports.setEditLayout = exports.actionCreator('SET_EDIT_LAYOUT');
exports.setDarkMode = exports.actionCreator('SET_DARK_MODE');
exports.setCrudePath = exports.actionCreator('SET_CRUDE_PATH');
exports.setCrudeTabs = exports.actionCreator('SET_CRUDE_TABS');
exports.setActiveTab = exports.actionCreator('SET_ACTIVE_TAB');
exports.setActiveEntity = exports.actionCreator('SET_ACTIVE_ENTITY');
exports.setLastActiveEntity = exports.actionCreator('SET_LAST_ACTIVE_ENTITY');
exports.setTableFilterSettings = exports.actionCreator('SET_TABLE_FILTER_SETTINGS');
exports.setDataDisplayMode = exports.actionCreator('SET_DATA_DISPLAY_MODE');
exports.setShowDialog = exports.actionCreator('SET_SHOW_DIALOG');
exports.setShowCollapse = exports.actionCreator('SET_SHOW_COLLAPSE');
exports.addMessage = exports.actionCreator('ADD_MESSAGE');
exports.setReloadListEntity = exports.actionCreator('RELOAD_LIST_ENTITY_DATA');
exports.setCrudeFilter = exports.actionCreator('SET_CRUDE_FILTER');
exports.setDataCache = exports.actionCreator('SET_DATA_CACHE');
exports.loadFilterData = exports.actionCreator('LOAD_FILTER_DATA');
exports.setTemporaryJoinData = exports.actionCreator('SET_TEMPORARY_JOIN_DATA');
